export const DefaultNonHealthMessage = "We are here to offer advice regarding your pet's health. For all other queries please call Customer Services";
export const InfoSheet = "InfoSheet";
export const ChangeConnectionMode = "ChangeConnectionMode";
export enum CallDirectionOptions
{
	INBOUND,
	OUTBOUND
};
